import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddPlan from "./AddPlan";
import AddCompanyRevenue from "./AddCompanyRevenue";
import WebService from "../../utility/WebService";
import CustomTable from "../../components/CustomTable/CustomTable";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { toast } from "react-toastify";
import MembershipIESA from "./MembershipIESA";

const Membership = () => {
    const [isLoading, setLoading] = useState(false);
    const [pagePermission, setPagePermission] = useState({
        canView: false,
        canAdd: false,
        canEdit: false,
        canDelete: false,
    });
    const [showAddPlanModal, setShowAddPlanModal] = useState(false);
    const [data, setData] = useState<any>(null);
    const [showAddCompanyRevenueModal, setShowAddCompanyRevenueModal] = useState(false);
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState<any>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [planIdToDelete, setPlanIdToDelete] = useState<string | null>(null);
    const [companyRevenue, setCompanyRevenue] = useState<any>([]);
    const [selectedCompanyRevenue, setSelectedCompanyRevenue] = useState<any>(null);
    const [revenueIdToDelete, setRevenueIdToDelete] = useState<string | null>(null);
    const [showIESAModal, setShowIESAModal] = useState(false);

    useEffect(() => {
        getPlans();
        getCompanyRevenue();
    }, [])

    const getPlans = () => {
        setLoading(true);
        WebService.getAPI({
            action: `plan/get-plan`
        })
            .then((res: any) => {
                setLoading(false);
                const perm = res?.permissions || {};
                setPagePermission({
                    canView: perm.canView || false,
                    canAdd: perm.canAdd || false,
                    canEdit: perm.canEdit || false,
                    canDelete: perm.canDelete || false,
                });
                for (let i in res.data) {
                    res.data[i].action = (
                        <div>
                            {perm.canEdit && <PencilFill className='me-3 cursor-pointer' onClick={() => {
                                setShowAddPlanModal(true);
                                setSelectedPlan(res.data[i]);
                            }} />}
                            {perm.canDelete && <TrashFill color='#DC143C' className='cursor-pointer' onClick={() => {
                                setShowDeleteModal(true);
                                setPlanIdToDelete(res.data[i]._id);
                            }} />}
                        </div>
                    );
                }
                setPlans(res.data);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    const getCompanyRevenue = () => {
        WebService.getAPI({
            action: `company-revenue/get-company-revenue`
        })
            .then((res: any) => {
                for (let i in res.data) {
                    res.data[i].planIdsName = res.data[i].planIds.map((plan: any) => plan.planName).join(", ");
                    const perm2 = pagePermission;
                    res.data[i].action = (
                        <div>
                            {perm2.canEdit && <PencilFill className='me-3 cursor-pointer' onClick={() => {
                                setShowAddCompanyRevenueModal(true);
                                setSelectedCompanyRevenue(res.data[i]);
                            }} />}
                            {perm2.canDelete && <TrashFill color='#DC143C' className='cursor-pointer' onClick={() => {
                                setShowDeleteModal(true);
                                setRevenueIdToDelete(res.data[i]._id);
                            }} />}
                        </div>
                    );
                }
                setCompanyRevenue(res.data);
            })
            .catch((err: any) => {
            });
    }

    return (
        <>
            <AddPlan
                show={showAddPlanModal}
                handleClose={() => {
                    setShowAddPlanModal(false);
                    getPlans();
                    setSelectedPlan(null);
                }}
                data={selectedPlan}
            />
            <AddCompanyRevenue
                show={showAddCompanyRevenueModal}
                handleClose={() => {
                    setShowAddCompanyRevenueModal(false);
                    getCompanyRevenue();
                    setSelectedCompanyRevenue(null);
                }}
                data={selectedCompanyRevenue}
                plans={plans}
            />
            <MembershipIESA
                show={showIESAModal}
                handleClose={() => setShowIESAModal(false)}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (planIdToDelete) {
                        WebService.deleteAPI({
                            action: `plan/delete-plan/${planIdToDelete}`
                        }).then(() => {
                            toast.success('Plan deleted successfully');
                            setPlanIdToDelete(null);
                            setShowDeleteModal(false);
                            getPlans();
                        });
                    } else if (revenueIdToDelete) {
                        WebService.deleteAPI({
                            action: `company-revenue/delete-company-revenue/${revenueIdToDelete}`
                        }).then(() => {
                            toast.success('Company revenue deleted successfully');
                            setRevenueIdToDelete(null);
                            setShowDeleteModal(false);
                            getCompanyRevenue();
                        });
                    }
                }}
            />
            <div className="events-main">
                <Card className='event-card'>
                    {
                        isLoading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                        ) :
                            <>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='page-title'>Membership</div>
                                    <div className="d-flex gap-2">
                                        {pagePermission.canAdd && <CustomButton
                                            isLoading={false}
                                            label={'Add Plan'}
                                            onClick={() => {
                                                setShowAddPlanModal(true);
                                            }}
                                            style={{ width: 110 }}
                                        />}
                                        {pagePermission.canAdd && <CustomButton
                                            isLoading={false}
                                            label={'Add Company Revenue'}
                                            onClick={() => {
                                                setShowAddCompanyRevenueModal(true);
                                            }}
                                            style={{ width: 190 }}
                                        />}
                                        {pagePermission.canEdit && <CustomButton
                                            isLoading={false}
                                            label={'IESA Advantage'}
                                            onClick={() => {
                                                setShowIESAModal(true);
                                            }}
                                            style={{ width: 190 }}
                                        />}
                                    </div>
                                </div>
                                <CustomTable
                                    columns={[
                                        { id: 'planName', label: 'Plan Name', minWidth: 170 },
                                        { id: 'amount', label: 'Amount', minWidth: 100, align: 'center' },
                                        { id: 'action', label: 'Action', minWidth: 100, align: 'center' },
                                    ]}
                                    rows={plans}
                                    draggable
                                    currentPage={0}
                                    totalCount={plans.length}
                                    pageSize={10}
                                    onPageChange={() => { }}
                                />
                                <strong>Company's Revenue</strong>
                                <CustomTable
                                    columns={[
                                        { id: 'revenueName', label: 'Revenue', minWidth: 170 },
                                        { id: 'planIdsName', label: 'Plan', minWidth: 100, align: 'center' },
                                        { id: 'action', label: 'Action', minWidth: 100, align: 'center' },
                                    ]}
                                    rows={companyRevenue}
                                    draggable
                                    currentPage={0}
                                    totalCount={companyRevenue.length}
                                    pageSize={10}
                                    onPageChange={() => { }}
                                />
                            </>
                    }
                </Card>
            </div>
        </>
    )
}

export default Membership;